// extracted by mini-css-extract-plugin
export var badgeContainer = "styles-module--badgeContainer--a0d6a";
export var clickable = "styles-module--clickable--ccd9d";
export var code = "styles-module--code--4bd21";